const { SparkScroll } = require('react-spark-scroll-rekapi')({ invalidateAutomatically: true });
export default SparkScroll;


// WEBPACK FOOTER //
// ./src/config/Scrolly.js